"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetCard = void 0;
const react_1 = __importStar(require("react"));
const CatalogCard_1 = require("decentraland-ui/dist/components/CatalogCard/CatalogCard");
const utils_1 = require("./utils");
const utils_2 = require("../../modules/translation/utils");
const AssetCard = (props) => {
    const { asset, assetFilters } = props;
    const i18n = {
        listing: (0, utils_2.t)('@dapps.asset_card.listing'),
        listings: (0, utils_2.t)('@dapps.asset_card.listings'),
        available_for_mint: (0, utils_2.t)('@dapps.asset_card.available_for_mint'),
        available_listings_in_range: (0, utils_2.t)('@dapps.asset_card.available_listings_in_range'),
        cheapest_listing: (0, utils_2.t)('@dapps.asset_card.cheapest_listing'),
        not_for_sale: (0, utils_2.t)('@dapps.asset_card.not_for_sale'),
        owner: (0, utils_2.t)('@dapps.asset_card.owner'),
        owners: (0, utils_2.t)('@dapps.asset_card.owners'),
        cheapest_option: (0, utils_2.t)('@dapps.asset_card.cheapest_option'),
        cheapest_option_range: (0, utils_2.t)('@dapps.asset_card.cheapest_option_range'),
        most_expensive: (0, utils_2.t)('@dapps.asset_card.most_expensive'),
        most_expensive_range: (0, utils_2.t)('@dapps.asset_card.most_expensive_range'),
        also_minting: (0, utils_2.t)('@dapps.asset_card.also_minting')
    };
    const catalogItemInformation = (0, react_1.useMemo)(() => {
        return (0, utils_1.getCatalogCardInformation)(asset, i18n, assetFilters);
    }, [asset]);
    const isAvailableForMint = asset.isOnSale && asset.available > 0;
    const notForSale = !isAvailableForMint && !asset.minListingPrice;
    const price = (0, react_1.useMemo)(() => {
        var _a;
        return ((_a = catalogItemInformation.price) === null || _a === void 0 ? void 0 : _a.includes('-'))
            ? `${(0, utils_1.formatWeiToAssetCardEther)(catalogItemInformation.price.split(' - ')[0])} - ${(0, utils_1.formatWeiToAssetCardEther)(catalogItemInformation.price.split(' - ')[1])}`
            : catalogItemInformation.price
                ? (0, utils_1.formatWeiToAssetCardEther)(catalogItemInformation.price)
                : undefined;
    }, [catalogItemInformation.price]);
    const propsCard = {
        asset: {
            id: asset.id,
            url: asset.url,
            name: asset.name,
            rarity: asset.rarity,
            network: asset.network,
            creator: asset.creator
        },
        action: catalogItemInformation.action,
        actionIcon: catalogItemInformation.actionIcon,
        imagensrc: asset.thumbnail,
        extraInformation: catalogItemInformation.extraInformation,
        notForSale: notForSale,
        price: price,
        owners: `${asset.owners} ${asset.owners === 1 ? i18n.owner : i18n.owners}`
    };
    return react_1.default.createElement(CatalogCard_1.CatalogCard, Object.assign({}, propsCard));
};
exports.AssetCard = AssetCard;
//# sourceMappingURL=AssetCard.js.map